// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dd90f9fc","455":"074e70be","977":"412d674e"}[chunkId] + ".chunk.js";
};